import { useQuery } from '@tanstack/react-query'

import { ApiUrlPath, X_AUTH_TOKEN, IQuestion, AppMsg } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

export type TGetRandomQuestionData = {
  count: {
    total: number
    notAnsweredTotal: number
  }
  data: IQuestion[]
}

type TError = {
  msg: AppMsg
}

export default (category: string) => {
  const getRandomQuestion = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    let url = ApiUrlPath.GetRandomQuestion as string

    if (category !== 'any') {
      url += `?category=${category}`
    }

    const res = await fetch(
      url,
      {
        headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
        signal: abortController.signal,
      },
      200
    )

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TGetRandomQuestionData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<TGetRandomQuestionData, TError>(
    [ApiUrlPath.GetRandomQuestion, category],
    getRandomQuestion,
    {
      enabled: false,
      keepPreviousData: false,
      cacheTime: 0,
    }
  )
}
